import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import FormFileUpload, { type FileUploadItem } from '@/js/components/form/form-file-upload.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'residency-become-documents-upload',
  setup(__props, { expose: __expose }) {

const documentItems = ref<FileUploadItem[]>([]);
const uploadRef = ref<InstanceType<typeof FormFileUpload> | null>(null);

__expose({
  getReadyFiles: () => uploadRef.value?.getReadyFiles() ?? [],
  reset: () => uploadRef.value?.reset(),
  setSubmittingState: (isSubmitting: boolean) => uploadRef.value?.setSubmittingState(isSubmitting),
  resetSubmittingState: () => uploadRef.value?.resetSubmittingState(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormFileUpload, {
    ref_key: "uploadRef",
    ref: uploadRef,
    modelValue: documentItems.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((documentItems).value = $event))
  }, null, 8, ["modelValue"]))
}
}

})